import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SecretariaService } from '../../secretaria.service';
import { AlertsService } from 'app/shared/alerts.service';
import { Router } from '@angular/router';
import { Paciente } from 'app/core/interfaces/pacient-info.interface';
import { OverlayService } from 'app/shared/overlay.service';
import { APIGestaCardService } from 'app/core/api/gestacard.service';
import { Medico } from 'app/core/interfaces/medico.interface';
import { Enfermeiro } from 'app/core/interfaces/enfermeiro.interface';
import { Secretaria } from 'app/core/interfaces/secretaria.interface';
import { Organizacao } from 'app/core/interfaces/organizacao.interface';
import { logger } from '../../../../core/utils/console';

@Component({
  selector: 'app-secretaria-cadastrar-paciente',
  templateUrl: './secretaria-cadastrar-paciente.component.html',
  styleUrls: ['./secretaria-cadastrar-paciente.component.scss']
})
export class SecretariaCadastrarPacienteComponent implements AfterViewInit {

  form: FormGroup; 
  emails_medicos: Medico[] = [];
  emails_enfermeiros: Enfermeiro[] = [];
  secretaria: Secretaria;
  organizacao: Organizacao;

  bloqueado_por_limite_de_cartoes: boolean = false;

  loading: boolean = false; 

  @ViewChild('cadastro_paciente') componente_cadastro_paciente; 
  @ViewChild('imageUploader') file_uploader_component;

  constructor(
    private secretariaService: SecretariaService, 
    private snackService: AlertsService, 
    private router: Router, 
    private overlayService: OverlayService,
    private _apigestacard: APIGestaCardService
  ) { }


  ngOnChanges() {
    let form = this.componente_cadastro_paciente.form

    if (form.medico_app) {
      form.medico_app.valueChanges.subscribe((res) => {
        this.BuscarPerfilMedico(res);
      })
    }

    if (form.enfermeiro_app) {
      form.enfermeiro_app.valueChanges.subscribe((res) => {
        this.BuscarPerfilEnfermeiro(res);
      })
    }
  }

  ngAfterViewInit() {
    this.form = this.componente_cadastro_paciente.form; 
    this.BuscarDados();
  }

  BuscarDados() {
    this.secretariaService.GetListaMedicos().subscribe((res) => {
      this.emails_medicos = res; 
    });
    
    this.secretariaService.GetListaEnfermeiros().subscribe((res) => {
      this.emails_enfermeiros = res; 
    });

    this.secretariaService.GetUserData().subscribe((res) => {
      this.secretaria = res;

      this.secretariaService.GetOrganizacao().then((org) => {
        this.organizacao = org;
        this.AtualizarFormulario();
      })
    });
  }

  BuscarPerfilMedico(id: string) {
    if (!id) return;
    if (this.organizacao.instituicao_publica === 'S') return

    this.secretariaService.GetMedicoPorId(id).then((res) => {

      this.secretariaService.TotalCartoesUsadosPeloMedico(id).then((result) => {
        
        if (result >= res.maximo_cartoes) {
          
          this.bloqueado_por_limite_de_cartoes = true;

        }
        
      }).catch((err) => {

        logger.log("SecretariaCadastrarPacienteComponent -> BuscarPerfilSecretaria -> err", err)
        
      });

    }).catch(err => {

      logger.log('Error', err);

    })
  }

  BuscarPerfilEnfermeiro(id: string) {
    if (!id) return;
    if (this.organizacao.instituicao_publica === 'S') return

    this.secretariaService.GetEnfermeiroPorId(id).then((res) => {
      this.secretariaService.TotalCartoesUsadosPeloEnfermeiro(id).then((result) => {

        if (result >= res.maximo_cartoes) this.bloqueado_por_limite_de_cartoes = true;
  
      }).catch((err) => {

        logger.log("SecretariaCadastrarPacienteComponent -> BuscarPerfilSecretaria -> err", err)
        
      });
    }).catch(err => {

      logger.log('Error', err);

    })
  }

  AtualizarFormulario() {
    this.componente_cadastro_paciente.enabledSearchEmail = true
    this.componente_cadastro_paciente.urlChangePaciente = '/secretaria-alterar-pacientes'

    if (this.organizacao.instituicao_publica === 'S') {
      this.form.setControl('enfermeiro_app', new FormControl('', []));
      this.form.setControl('medico_app', new FormControl('', []));
      return
    }
    
    this.form.setControl('enfermeiro_app', new FormControl('', []));
    this.form.removeControl('cns');
  }

  SalvarPaciente() {

    if (this.form.valid) {

      this.loading = true;
      this.overlayService.show(); 

      var aux = this.form.value; 
      var paciente_criado = Paciente.create(aux); 

      this.secretariaService.CadastrarPaciente(paciente_criado).then(async (res) => {
        try {
          var imagem_aux = this.file_uploader_component.imagePath;

          if (imagem_aux) {
            var imagem = imagem_aux[0];
            var url_imagem = await this._apigestacard.UploadImage(imagem);

            var atualizando_perfil = await this._apigestacard.AtualizarUrlPerfil(res.id, url_imagem);
          }

          this.snackService.SnackMessage('Cadastro feito com sucesso!'); 

          this.router.navigate(['/secretaria']);
          
        } catch (error) {
          this.snackService.SnackMessage('Erro ao cadastrar paciente.'+(error.hasOwnProperty('message') ? ' '+error.message : '' ));
        }
      }).catch((err) => {
        var message = '';
        if (typeof err === 'string') message = err;
        if (err.hasOwnProperty('message')) message = err.message;

        if (message == '') message = 'Erro ao cadastrar paciente.';
        
        this.snackService.SnackMessage(message); 

      }).finally(() => {

        this.loading = false;

        this.overlayService.hide(); 

      })

    } else {

      let errors = []; // string com os erros do formulário
      if (this.form.invalid && this.form.controls) {
        Object.keys(this.form.controls).forEach(key => {
          const controlErrors = this.form.get(key).errors;
          if (controlErrors != null) {
            Object.keys(controlErrors).forEach(keyError => {
              errors.push(`O campo ${key} possui o erro: ${keyError}`);
            });
          }
        });
      }

      this.snackService.SnackMessage('Formulário invalido. Erros: ' + errors.join(', ')); 

    }
  }

}
